import Modal from 'common/modal';

type Props = {
  // eslint-disable-next-line @typescript-eslint/ban-types
  onExitClick?: Function;
  paymentForm: JSX.Element;
  setShowModal: (value: boolean) => void;
  showModal: boolean;
};

export default function CreatePaymentModal({
  onExitClick,
  paymentForm,
  setShowModal,
  showModal,
}: Props) {
  const _onExitClick = () => {
    onExitClick && onExitClick();
    setShowModal(false);
  };

  return (
    <Modal
      setShowModal={setShowModal}
      onExitClick={_onExitClick}
      showModal={showModal}
      showActions={false}
      content={paymentForm}
      loading={false}
      actionDisabled={false}
      maxWidth="md"
    />
  );
}
